export const LARGE_WIDTH = 1000;
export const MEDIUM_WIDTH = 768;
export const SMALL_WIDTH = 300; // Assumed device width is 320

export const getSizeByWidth = width => {
  if (width >= LARGE_WIDTH) return 'lg';
  if (width < LARGE_WIDTH && width >= MEDIUM_WIDTH) return 'md';
  return 'sm';
};
